<template>
    <b-row v-if="contrato !== undefined" class="ml-1 d-flex align-items-start">
        <b-col cols="12" md="6">
            <b-row class="d-flex align-items-start">
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Número do Contrato Centralizado" v-slot="defaultState">
                        <b-form-input id="input-numero" v-model="contrato.NrContratoOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defaultState.state"
                            rules="max:8">
                        </b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="0" md="2" class="d-flex justify-content-center align-items-center mt-4 pt-2">
                    <span class="h2">/</span>
                </b-col>
                <b-col cols="12" md="4">
                    <default-form-validation-provider label="Ano do Contrato centralizado" v-slot="defaultState">
                        <b-form-input id="input-ano" v-model="contrato.NrAnoContratoOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defaultState.state"
                            type="number"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12">
                        <default-form-validation-provider label="CNPJ Órgão Responsável" rules="required|min:14|max:14|numeric"
                            v-slot="defState">
                            <b-form-input v-model="contrato.NrCnpjOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defState.state" />
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" md="5">
                        <default-form-validation-provider label="Órgão Responsável" rules="required|max:120"
                            v-slot="defState">
                            <b-form-input v-model="contrato.NmOrgaoResp" @change="procedimentoOrigemAtualizado" :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import { ContratoCentralizado } from '@/types/licitacoes/contratos/contrato-centralizado'

const CompProps = Vue.extend({
    name: 'EditarProcedimentoOrigemDispensaContratoCentralizado',
    components: { DefaultFormValidationProvider },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class EditarProcedimentoOrigemContratoCentralizado extends mixins(UtilsTS, CompProps) {
    contrato: Contrato = new Contrato()

    async mounted() {
        try {
            this.contrato = this.ctr
            store.blockScreen = true
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarProcedimentoOrigemContratoCentralizado', e)
        } finally {
            store.blockScreen = false
        }
    }

    procedimentoOrigemAtualizado() {
        this.$emit('input', this.contrato)
    }
}


</script>

<style scoped>
    :deep(svg) {
        padding-bottom: 0.75em;
    }
</style>